import $ from 'jquery'
import config from '@/config'
import app from '@/main'
import { ApiErrors } from '@/types/codes'
import { tokenManager, ITokenData } from './tokenManager'

interface IHttpRes<T> {
  data: T
  code: number
  msg: string
  ts: number
  status: number
  statusText: string
  headers: any
}

class Http {

  public baseURL: string = config.baseURL

  public defaultSettings: any = {
    handleBizError: true,
    handleSysError: true,
    checkToken: true,
    beforeSend: (jqXHR: JQuery.jqXHR) => {
      jqXHR.setRequestHeader('x-rpc-wrap', '1')
      jqXHR.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      jqXHR.setRequestHeader(tokenManager.HttpHeaderName, config.token())
    }
  }

  private ignoreDuplicateOf = [
    'age', 'authorization', 'content-length', 'content-type', 'etag',
    'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
    'last-modified', 'location', 'max-forwards', 'proxy-authorization',
    'referer', 'retry-after', 'user-agent'
  ]

  public request<T>(url: string, settings?: JQuery.AjaxSettings) {
    let defer = $.Deferred<IHttpRes<T>>()
    let options = $.extend(true, {}, this.defaultSettings, settings)
    let sendAjax = () => {
      $.ajax(this.baseURL + url, options)
        .done((data: any, textStatus: string, jqXHR: JQuery.jqXHR) => {
          let res = this.jqXhrToRes(jqXHR) as IHttpRes<T>
          res = { ...res, ...data }
          if (res.code == 200) {
            defer.resolve(res)
          } else if (res.code === ApiErrors.TokenExpired) {
            defer.resolve(res)
            app.$warning({
              title: '登录失效',
              content: '请重新登录',
              onOk() {
                window.location.href = '/user/#/login'
              },
            });
          } else {
            defer.resolve(res)
          }
        })
        .fail((jqXHR: JQuery.jqXHR, textStatus: string, errorThrown: string) => {
          if (options.handleSysError) {
            if (jqXHR.status == 0) {
              // 接口请求未成功，如跨域、网络不通等情况
              // 提示请求失败信息
            }
            if (jqXHR.status == 401) {

            }
            if (jqXHR.status == 400) {

            }
            if (jqXHR.status == 500) {

            }
          }
          defer.reject(jqXHR)
        })
    }

    if (options.checkToken) {
      tokenManager.refreshToken().then(() => {
        sendAjax()
      }, () => {
        tokenManager.goLogin()
      })
    } else {
      sendAjax()
    }

    return defer.promise()
  }

  public get<T>(url: string, settings?: JQuery.AjaxSettings) {
    return this.request<T>(url, { method: 'GET', ...settings })
  }

  public post<T>(url: string, data: any, settings?: JQuery.AjaxSettings) {
    data = JSON.stringify(data)
    return this.request<T>(url, { method: 'POST', data, ...settings })
  }

  public delete<T>(url: string, settings?: JQuery.AjaxSettings) {
    return this.request<T>(url, { method: 'DELETE', ...settings })
  }

  public put<T>(url: string, data: any, settings?: JQuery.AjaxSettings) {
    return this.request<T>(url, { method: 'PUT', data, ...settings })
  }

  private jqXhrToRes(jqXHR: JQuery.jqXHR) {
    return {
      status: jqXHR.status,
      statusText: jqXHR.statusText,
      headers: this.parseHeaders(jqXHR.getAllResponseHeaders())
    }
  }

  private trim(str: string) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '')
  }

  private parseHeaders(headers: string) {
    let parsed: any = {}
    if (!headers) {
      return parsed
    }
    headers.split('\n').forEach((line: string) => {
      let i = line.indexOf(':')
      let key = this.trim(line.substr(0, i)).toLowerCase()
      let val = this.trim(line.substr(i + 1))
      if (key) {
        if (parsed[key] && this.ignoreDuplicateOf.indexOf(key) >= 0) {
          return
        }
        if (key === 'set-cookie') {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val])
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val
        }
      }
    })
    return parsed
  }

}

/**
 * Ajax请求对象
 */
let http = new Http()

export default http
